import React from 'react';
import AppHeader from '../../../../components/Header/Header';
import AppFooter from '../../../../components/Footer/footer';
import CienciaSaudeMenu from '../../../../components/ui/CienciaSaudeMenu';
import BannerSection from '../../../../components/ui/BannerSection';
import SectionHeading from '../../../../components/SectionHeading';
import BreadcrumbNav from '../../../../components/ui/BreadcrumbNav';

const caminho = [
    { label: 'Home', href: '/', icon: 'bi bi-house-door' },
    { label: 'Programa' },
    { label: 'Unidade Orgânica', href: '/programas/unidade-organica' },
    { label: 'Ciências da Saúde', href: '/programas/unidade_organica/ciencia_saude' },
    { label: 'Missão, Visão e Valores' }
];


function Missao_visao_valoresCS() {
    return (
        <>
        <header id='header'>
        <AppHeader />
        </header>
        <BannerSection
                title="Missão, Visão e Valores"
                subtitle="Unidade Orgânica de Ciências da Saúde"
                description={`Conheça a missão, visão e valores que guiam a Unidade Orgânica de Ciências da Saúde, comprometida com a excelência na formação de profissionais de saúde.`}
                backgroundImage={require('../../../../assets/img-heroUN.jpg')}
                backgroundId="instituition-Banner"
            />
        <BreadcrumbNav items={caminho} />
        <main className="px-3 px-md-5 px-xl-5 px-xxl-5 py-2">
        <br />
        <div className="row flex-row-reverse">
        <div className="col-12 col-md-4 col-lg-3 col-xl-2 col-xxl-2">
            <CienciaSaudeMenu />
            </div>
        <div className="col-12 col-md-8 col-lg-9 col-xl-10 col-xxl-10">
                <br />
                <div style={{marginLeft:'50px'}} className="details-magazine">
                <p className="f-reg f-20">
                     <SectionHeading title="Missão" />
                    <br />
                    Preparar quadros com conhecimento científico, Técnico e cultural em ramos ou especialidades correspondentes a áreas diferenciadas do saber.
                    
                    <br />
                    Realizar a formação em estreita ligação com a investigação científica orientada para solução dos problemas de acordo as épocas e situações e inserida no quadro do conhecimento da ciência, da técnica e da tecnologia;<br /><br />
                    Preparar e assegurar o exercício da reflexão critica e da participação na produção científica;<br /><br />
                    Realizar cursos de graduação e pós-graduação ou especialização para a superação científica e técnica dos quadros de alto nível superior;<br />
                    Promover a pesquisa e a divulgação dos seus resultados para o enriquecimento e desenvolvimento multifacetico do país;<br /><br />
                    Promover acções que contribuam para o desenvolvimento da comunidade em que a instituição está inserida.
                    Espírito altruísta e solidário para as pessoas mais vulneráveis da sociedade, como prova a prática de cobrança  de metade de preço de propinas em relação as outras Instituições do Ensino Superior do mercado Angolano.
                </p>
                <br />
                <p className="f-reg f-20">
                    <SectionHeading title="Visão" />
                    <br />
                    Construir e difundir o conhecimento, comprometido com a formação de pessoas
                    capazes de inovar e contribuir para o desenvolvimento da sociedade, de modo
                    sustentável.<br/><br/>
                    Promover a qualificação de alto nível, a produção, transmissão, crítica e difusão de saber, cultura,
                    ciência e tecnologia, através do estudo, da docência e da investigação”.<br/><br/>
                    A continuação da sua visão é orientada pela:<br/><br/>
                    ➢ Produção de conhecimento, assente na excelência da investigação e da docência;<br/><br/>
                    ➢ Disseminação do saber científico, através de uma oferta formativa distintiva e integral, satisfazendo
                    as necessidades de formação da sociedade e favorecendo a inovação;<br/><br/>
                    ➢ Transferência do conhecimento em prol do desenvolvimento económico, tecnológico e social,
                    concorrendo para a melhoria da competitividade das empresas e da qualidade de vida dos
                    cidadãos.
                </p>
                <br />
                <p className="f-reg f-20">
                    <SectionHeading title="Valores" />
                    <br />
                    <b className="text-success">Qualidade E Excelência:</b> Prontidão, espírito de sacrifício, compromisso mútuo e liderança.;<br /> 
                    <b className="text-success">Responsabilidade:</b> Imparcialidade, qualidade, colaboração, inovação e credibilidade;    <br /> 
                    <b className="text-success">Transparência:</b> Abertura ao escrutínio público sobre nossas acções, processos e uso de nossos recursos;  <br />
                    <b className="text-success">Diversidade: </b>Promove uma consciência global que valorize a investigação científica, promovendo projectos e linhas de pesquisas relevantes para a comunidade onde está inserida  a sociedade em geral; em diversas áreas de saber.  <br /> 
                    <b className="text-success">Integridade:</b> consistentemente abraçando e praticando honestidade, verdade, assistência  e humanização em tudo o que fazemos;<br />  
                    <b className="text-success">Respeito: </b>Tratando todas as partes interessadas com civilidade e dignidade, incluindo o espeito a identidade e a diversidade;<br />  
                    <b className="text-success">Responsabilidade Social, Envolvimento da Comunidade:</b> Contribuindo da melhor forma possível para o bem-estar intelectual, social e económico das comunidades que servimos; <br /> 
                    <b className="text-success">Rigor:</b> Rigidez na formação de profissionais capazes de fornecer assistência de serviços de saúde, planificação e acompanhamento ou monitoramento dos trabalhos prestados. <br /> 
                    <br />
                </p>
                <br />
                </div>
                <br /><br />
            </div>
        </div>
        <br />
        <br />
        <br />
        <br />
        <br />
        </main>
        <footer id="footer">
        <AppFooter />
      </footer>
        </>
    );
}

export default Missao_visao_valoresCS;